import { Stack, styled, Typography, type CSSObject } from '@mui/material';

import {
  Section,
  Testimonial,
} from '@rumblefish/ui/src/components/Rumblefish23Theme';

export const CustomerTestimonialSection = styled(Section)(() => ({
  contain: 'paint',
  overflow: 'hidden',
}));

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  position: 'relative',
  gap: theme.spacing(8),
  margin: theme.spacing(10, 0),
  [theme.breakpoints.down('lg')]: {
    margin: theme.spacing(16, 0, 10, 0),
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(8, 0),
    gap: theme.spacing(3),
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    margin: theme.spacing(6, 0, 6, 0),
  },
}));

export const StyledQuote = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontSize: '98px !important',
  lineHeight: '92px !important',
  height: '50px',
  [theme.breakpoints.up(800)]: {
    display: 'none',
  },
  width: 'min-content',
}));

export const TestimonialWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('xl')]: {
    height: '424px',
  },
}));

export const StyledTestimonial = styled(Testimonial)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    [theme.breakpoints.down('xl')]: {
      alignItems: 'center',
    },
    ['div:nth-of-type(1)']: {
      [theme.breakpoints.down('xl')]: {
        minWidth: 'auto',
        width: '310px',
        height: '310px',
      },
    },
    ['div:nth-of-type(2)']: {
      div: {
        width: 'auto',
        height: 'auto',
      },

      [theme.breakpoints.down(1625)]: {
        flex: 1,
        padding: theme.spacing(3, 14, 3, 26),
        div: {
          span: {
            fontSize: '20px !important',
          },
        },
      },
    },
  },
  ['>div:nth-of-type(2)']: {
    minWidth: 'auto',
    maxWidth: 'none',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3.5, 11, 2, 19),
    },
    [theme.breakpoints.down(800)]: {
      padding: '0px',
    },
  },
}));
